import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CleverInputProps } from 'UI/Input';
import { isValidTime, normalizeTime } from 'utils/date';
import { SInputTime } from './InputTime.styled';

type InputTimeProps = Omit<CleverInputProps, 'validateInput'>;

const ALLOWED_CHARS = /^[\d:]*$/;

export const InputTime = ({
  placeholder,
  value,
  initialValue,
  onChange,
  onChangeDebounced,
  onBlur,
  ...props
}: InputTimeProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(value ?? initialValue ?? '');
  const isInvalid = inputValue.length > 0 && !isValidTime(inputValue);

  useEffect(() => {
    if (value !== undefined) {
      setInputValue(value);
    }
  }, [value]);

  return (
    <SInputTime
      {...props}
      value={inputValue}
      initialValue={initialValue}
      placeholder={placeholder ?? t('common.time_format_placeholder', 'hh:mm')}
      maxLength={5}
      $isInvalid={isInvalid}
      validateInput={(val: string) => ALLOWED_CHARS.test(val)}
      onChange={(val, e) => {
        setInputValue(val);
        onChange?.(val, e);
      }}
      onChangeDebounced={(val, e) => {
        if (val !== inputValue) {
          return;
        }
        onChangeDebounced?.(val, e);
      }}
      onBlur={(val, e) => {
        const normalized = normalizeTime(val);
        setInputValue(normalized);
        if (normalized !== val) {
          onChangeDebounced?.(normalized, undefined);
        }
        onBlur?.(normalized, e);
      }}
    />
  );
};
